import { useMerchant } from "context/merchant";
import { openCloseAPI } from "../api/settingsApi";

// Системээс гарах логик. Дэлгүүр хаах алдаа гарсан ч LOGOUT-ийг ЗОГСООХГҮЙ —
// эс бөгөөс серверийн алдаа = системээс гарч чадахгүй болно.
export function useLogout() {
  const { clearMerchantInfo } = useMerchant();

  return async function logout() {
    try {
      await openCloseAPI({ isOpen: false });
    } catch (error) {
      console.error("Logout openClose error:", error);
    }
    localStorage.clear();
    clearMerchantInfo();
    window.location.reload(); // гарахад бүх төлөв цэвэрлэх нь ЗӨВ (reload зориуд)
  };
}
